import { ShieldCheck } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { BrandMark } from '../../components/BrandMark'

export function LoginPage() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const enterPreview = () => {
    localStorage.setItem('dawn-demo-session', 'true')
    navigate('/app/overview')
  }

  return <section className="auth-page">
    <div className="auth-panel">
      <BrandMark light />
      <div>
        <h1>Enter the Command Centre</h1>
        <p>Review the Deus Intus Tenant 001 production-pilot configuration. The interface shows real rollout scope and controls, but no live source or external action is connected yet.</p>
      </div>
      <form onSubmit={event => { event.preventDefault(); enterPreview() }}>
        <label>Work email<input value={email} onChange={event => setEmail(event.target.value)} type="email" placeholder="name@company.co.uk" /></label>
        <label>Password<input value={password} onChange={event => setPassword(event.target.value)} type="password" placeholder="••••••••••••" /></label>
        <button className="button button--gold" type="submit">Open Tenant 001 pilot preview</button>
      </form>
      <div className="auth-divider"><span>or</span></div>
      <button className="button button--outline" onClick={enterPreview}>Open read-only review environment</button>
      <small><ShieldCheck size={13} /> Production authentication will be enforced by Cloudflare Access before remote deployment.</small>
    </div>
    <div className="auth-art">
      <div className="auth-sun"><span /></div>
      <blockquote>“Prove the operating system on our own business before asking another client to trust it.”</blockquote>
    </div>
  </section>
}
